import React from 'react';
import styled, { css } from 'styled-components';
import { RhTab } from './RhTabs';
import { colors, Regular } from './Styles';

type Props = {
  /** ID of the tab that's currently active */
  activeId: string;
  /** List of tabs to be displayed */
  tabs: RhTab[];
  isDisabled?: boolean;

  /** fired when user clicks a tab */
  onSelect: (id: string) => void;
};

/**
 * A general purpose controlled tab component
 * that is specific for Risen Hope
 * @param props
 */
export const RhTabBar: React.FC<Props> = props => {
  return (
    <TabContainer>
      {props.tabs.map(tab => {
        const isActive = props.activeId === tab.id;
        return (
          <Tab
            key={tab.id}
            active={isActive}
            disabled={props.isDisabled}
            onClick={() => props.onSelect(tab.id)}
            style={{ opacity: props.isDisabled ? 0.5 : 1 }}>
            <TabText weight="bold" color={isActive ? '#fff' : colors.grey}>
              {tab.title}
            </TabText>
          </Tab>
        );
      })}
    </TabContainer>
  );
};

const TabContainer = styled.div`
  display: inline-flex;
  background: ${colors.faintGrey};
  border-radius: 25px;
`;

const Tab = styled.button<{ active?: boolean }>`
  all: unset;
  appearance: none;
  outline: none;
  white-space: nowrap;
  text-align: center;
  min-width: 170px;
  padding: 8px;
  ${({ active }) =>
    active &&
    css`
      background: ${colors.primary};
      box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.19);
      border-radius: 25px;
    `}
`;

const TabText = styled(Regular)`
  line-height: 26px;
`;
